import { render, staticRenderFns } from "./GroupCertificateList.vue?vue&type=template&id=adc1264a&scoped=true&"
import script from "./GroupCertificateList.vue?vue&type=script&lang=js&"
export * from "./GroupCertificateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc1264a",
  null
  
)

export default component.exports